import { useState } from 'react';
import { Control, FieldValues, Path, useController } from 'react-hook-form';

import { usePollContext } from '../../../../Context';
import { getCanEditPollStudentResponses } from '../helpers';

export interface Props<T extends FieldValues> {
  control: Control<T, object>;
  name: Path<T>;
}

const useStudentResponsesVM = <T extends FieldValues>({ control, name }: Props<T>) => {
  const { poll } = usePollContext();

  const canEditStudentResponses = getCanEditPollStudentResponses(poll ?? undefined);

  const controllerMethods = useController({ control, name });

  const [isEditStudentResponsesDialogOpen, setIsEditStudentResponsesDialogOpen] = useState(false);

  const onEditStudentResponses = () => {
    setIsEditStudentResponsesDialogOpen(true);
  };

  const onCloseEditStudentResponsesDialog = () => {
    setIsEditStudentResponsesDialogOpen(false);
  };

  return {
    canEditStudentResponses,
    controllerMethods,
    isEditStudentResponsesDialogOpen,
    onEditStudentResponses,
    onCloseEditStudentResponsesDialog,
  };
};

export default useStudentResponsesVM;
